import { ReactNode } from 'react';
import styled from '@emotion/styled';

export const HeaderWrapper = styled.div`
    padding-right: 48px;
`;

export const Eyebrow = styled.span`
    display: inline-flex;
    align-items: center;
    padding: 6px 10px;
    border-radius: 999px;
    background: rgba(131, 83, 226, 0.1);
    color: #6d41d8;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
`;

export const Title = styled.h2`
    margin: 10px 0 0;
    color: #111827;
    font-size: 22px;
    font-weight: 700;
    line-height: 1.2;
`;

export const Subtitle = styled.p`
    margin: 6px 0 0;
    color: #64748b;
    font-size: 14px;
    line-height: 1.5;
`;

type ModalHeaderProps = {
    eyebrow?: ReactNode;
    title: ReactNode;
    subtitle?: ReactNode;
};

export const ModalHeader = ({ eyebrow, title, subtitle }: ModalHeaderProps) => (
    <HeaderWrapper>
        {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
        <Title>{title}</Title>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </HeaderWrapper>
);

export default ModalHeader;
